/// <amd-module name="Wit/DeliveryPlans/Common/Components/TeamSettingsTable/TeamSettingsInterfaces" />

import { IObservableArray, IObservableValue } from "VSS/Core/Observable";
import { IListBoxItem } from "VSSUI/ListBox";
import { DropdownSelection } from "VSSUI/Utilities/DropdownSelection";

/**
 * The currently selected values in a row
 */
export interface ITeamSelectedSettingData {
    /**
     * Current selected backlog level id
     */
    backlogLevel: string;

    /**
     * Currently selected project id
     */
    project: string;

    /**
     * Currently selected team id
     */
    team: string;
}

/**
 * Model representing a single row of settings data - dropdown choices and currently selected values
 */
export interface ITeamSettingData extends ITeamSelectedSettingData {
    /**
     * Available backlog levels in the dropdown
     */
    backlogLevels: IObservableArray<IListBoxItem>;
    backlogSelection: DropdownSelection;

    /**
     * Id generated on the fly that is used to generate unique table cell keys
     */
    id: string;

    /**
     * Available project options in dropdown
     */
    projects: IObservableArray<IListBoxItem>;
    projectSelection: DropdownSelection;

    /**
     * True if teams and backlog are ready, false if data is being loaded
     */
    ready: IObservableValue<boolean>;

    /**
     * Available team options in the dropdown
     */
    teams: IObservableArray<IListBoxItem>;
    teamSelection: DropdownSelection;
}
